
import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  isOffline: Boolean(!window.navigator.onLine),
  trainingPageLimit: localStorage.getItem("training_page_limit") || 6,
  dropInPageLimit: localStorage.getItem("drop_in_page_limit") || 18,
  bookingPageLimit: 5,
};

export const uiCtrlSlice = createSlice({
  name: "uiCtrlSlice",
  initialState,
  reducers: {
    setIsOffline: (state, action) => {
      state.isOffline = action.payload;
    },
    setTrainingPageLimit: (state, action) => {
      state.trainingPageLimit = action.payload;
      localStorage.setItem("training_page_limit", action.payload)
    },
    setDropInPageLimit: (state, action) => {
      state.dropInPageLimit = action.payload;
      localStorage.setItem("drop_in_page_limit", action.payload)
    }
  },
});

export const { setIsOffline, setTrainingPageLimit, setDropInPageLimit } = uiCtrlSlice.actions;

export default uiCtrlSlice.reducer;
